<template>
  <div id="app">
    <div class="page-container">
      <!-- 顶部 -->
      <div class="header">
        <!-- 首页界面 -->
        <div class="welcome-area" v-show="homeFlag">
          <!-- <span class="el-icon-star-on"></span> -->
          <!-- <span>徐州医科大学问卷调查</span> -->
          <span>{{ title }}</span>
          <!-- <span class="el-icon-star-on"></span> -->
        </div>

        <!-- 返回按钮 -->
        <div class="back-area" v-show="backFlag" @click="backToHome">
          &nbsp;<span class="el-icon-back"></span>&nbsp;
          <span>返回</span>
        </div>

        <!-- 评分界面 -->
        <div class="score-area" v-show="scoreFlag">
          <span class="el-icon-star-on"></span>
          <span>答题完毕，欢迎再次使用</span>
          <span class="el-icon-star-on"></span>
        </div>

      </div>
      <!-- 中间答题区域 -->
      <div class="question-area">
        <transition name="el-fade-in-linear" mode="out-in">
          <router-view @update-title="updateTitle"></router-view>
        </transition>
      </div>

      <div class="footer">
        <div class="welcome-area">
          Copyright © 江苏省大学生心理危机预防与干预研究中心
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
      homeFlag: true,
      backFlag: false,
      scoreFlag: false,
      title: '心理健康多模态情绪综合测评量表(MQ69)'
    }
  },
  methods: {
    // 终端设备判断：
    // _isMobile() {
    //   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //   return flag;
    // },
    updateTitle(newTitle) {
      // this.title = newTitle;
      if (newTitle !== undefined && newTitle !== null && newTitle !== '') {
        this.title = newTitle;
      }
      // this.title = newTitle !== undefined ? newTitle : '徐州医科大学问卷调查';
    },
    backToHome() {
      this.$store.commit('resetStore')
      this.$router.push('/')
    },
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
    var that = this;
    var t = that.$route.params.t;
    var title = '';
    if (t) {
      switch (t) {
        case 'u':
          title = '大学生心理健康多模态情绪综合测评量表(MQ69)';
          break;
        case 'h':
          title = '高中生心理健康多模态情绪综合测评量表(MQ69)';
          break;
        default:
          break;
      }
    }
    that.updateTitle(title);
  },
  mounted() {
    // 终端设备判断：
    // if (this._isMobile()) {
    //   this.$router.replace('/');
    // } else {
    //   this.$router.replace('/w_index');
    // }
    if (this.$route.path === '/sj') {
      this.homeFlag = true
      this.backFlag = false
      this.scoreFlag = false
    } else if (this.$route.path === '/question') {
      this.homeFlag = true
      this.backFlag = false
      this.scoreFlag = false
    } else if (this.$route.path === '/video') {
      this.homeFlag = false
      this.backFlag = false
      this.scoreFlag = false
    } else if (this.$route.path === '/score') {
      this.homeFlag = false
      this.backFlag = false
      this.scoreFlag = true
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.fullPath === '/js') {
          this.homeFlag = true
          this.backFlag = false
          this.scoreFlag = false
        } else if (val.fullPath === '/question') {
          this.homeFlag = true
          this.backFlag = false
          this.scoreFlag = false
        } else if (val.fullPath === '/video') {
          this.homeFlag = false
          this.backFlag = false
          this.scoreFlag = false
        } else if (val.fullPath === '/score') {
          this.homeFlag = false
          this.backFlag = false
          this.scoreFlag = true
        }

      },
      // 深度观察监听
      deep: true
    }
  }

}
</script>

<style>
[v-cloak] {
  /*解决第一次进入页面时出现代码等待渲染的情况*/
  display: none !important;
}

* {
  margin: 0;
  padding: 0;
}

body {
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

html,
body {
  font-size: 62.5%;
  max-width: 720px;
  height: 100%;
  margin: 0 auto;
}

#app,
.page-container {
  height: 100%;
  width: 100%;
}

.page-container {
  display: flex;
  flex-direction: column;
}

.question-area {
  padding: 0 1rem;
  flex: 1;
}

.header {
  height: 5.0rem;
  line-height: 5.0rem;
  background-color: #3D444C;
  color: #ffffff;
  font-size: 1.6rem;
}

.welcome-area,
.score-area {
  text-align: center;
}

.back-area {
  width: 10rem;
  cursor: pointer;
}

.footer {
  height: 5rem;
  line-height: 5rem;
  background-color: #3D444C;
  color: #ffffff;
}

@media (max-width: 720px) {
  .el-message-box {
    width: 320px !important;
  }

  .el-dialog {
    width: 80% !important;
  }
}
</style>
